import * as React from "react"
import { IIndicator } from "../../index"

interface Props extends IIndicator {
    showLabel: boolean
    isLink: boolean
    withPadding: boolean
}

export const SingleValueIndicator = ({
    color,
    description,
    id,
    isLink,
    showLabel,
    title,
    url,
    value,
    withPadding,
}: Props): JSX.Element => {
    let colorClass = "bg-nickel"
    if (color === "green") {
        colorClass = "bg-jade"
    } else if (color === "yellow") {
        colorClass = "bg-aureolin"
    } else if (color === "red") {
        colorClass = "bg-cadmium-red"
    }

    const content = (
        <>
            <div className={`progress-bar ${colorClass}`}></div>
            <h2 className="tw-p-1 tw-pb-0">{value}</h2>
            {showLabel && (
                <div
                    className="label"
                    dangerouslySetInnerHTML={{
                        __html: title,
                    }}
                />
            )}
        </>
    )

    const wrapperClasses =
        "text-black theme-card-link bg-cloud tw-flex-col-center full-size tw-p-4 tw-text-center tw-overflow-hidden"

    return (
        <article
            className="tw-w-full tw-self-start lg:tw-w-1/4"
            data-ft-component="indicatorCard"
            data-ft-description={description}
            data-ft-indicator-id={id}
            data-ft-indicator-type="singleValue"
            data-ft-title={title}
            data-ft-value={value}
            title={description}
        >
            <div className={`full-size ${withPadding ? "tw-p-2" : ""}`}>
                {isLink ? (
                    <a
                        href={url}
                        className={wrapperClasses}
                        data-ft-component="indicatorLink"
                    >
                        {content}
                    </a>
                ) : (
                    <div className={wrapperClasses}>{content}</div>
                )}
            </div>
        </article>
    )
}

SingleValueIndicator.defaultProps = {
    isLink: true,
    showLabel: true,
    withPadding: true,
}

export default SingleValueIndicator
